import * as config from '../constants/config';
import webIMConfig from '../libs/webIMConfig';
import moment from 'moment';
import {
  CONVERSATION_STATUS,
  ConversationStatusType,
  MEMBER_TYPES,
  MESSENGER_UPGRADE_ACTION,
  MessengerUpgradeActionType,
  MemberShipType,
} from '../constants/constants';

class ConversationStatus {
  status: ConversationStatusType;
  remaining: number;
  remainingCredits: number;
  canSend: boolean;
  reason: string;
  canVideoCall: boolean;
  canSendPrivate: boolean;
  canSendPhotos?: boolean;
  memberLevelUserLogin: number;
  isRecvMatching: boolean;
  isSenderMatching: boolean;
  receiverMemberLevel: MemberShipType;
  timeToReset: number;
  upgradeAction: MessengerUpgradeActionType;
  conversationKey: string;
  isCreditSend: boolean;
  canSendGifts: boolean;
  messageBanExpiry: number;
  sendPhotosBanExpiry: number;
  diffTime: number;
  constructor() {
    this.status = CONVERSATION_STATUS.ERROR_OCCUR;
    this.remaining = 0;
    this.remainingCredits = 0;
    this.canSend = false;
    this.reason = '';
    this.canVideoCall = true;
    this.canSendPrivate = true;
    this.memberLevelUserLogin = 0;
    this.isRecvMatching = false;
    this.isSenderMatching = false;
    this.receiverMemberLevel = MEMBER_TYPES.GUEST;
    this.timeToReset = 0;
    this.upgradeAction = MESSENGER_UPGRADE_ACTION.NONE;
    this.conversationKey = '';
    this.isCreditSend = false;
    this.canSendGifts = false;
    this.messageBanExpiry = 0;
    this.sendPhotosBanExpiry = 0;
    this.diffTime = 0;
  }

  static mappingObject(_statusObject: any, isMobileWeb?: boolean): ConversationStatus {
    const convStatus = new ConversationStatus();

    let editorStatus;
    let _messageBanExpiry = 0;
    let _sendPhotosBanExpiry = 0;
    if (_statusObject.MessageBanExpiry) {
      const exp = moment(_statusObject.MessageBanExpiry);
      const now = moment();
      _messageBanExpiry = exp.diff(now) / 1000 / 60;
    }
    if (_statusObject.SendPhotosBanExpiry) {
      const exp = moment(_statusObject.SendPhotosBanExpiry);
      const now = moment();
      _sendPhotosBanExpiry = exp.diff(now) / 1000 / 60;
    }
    if (_statusObject.TimeStamp) {
      convStatus.diffTime = moment(_statusObject.TimeStamp).diff(moment());
    }

    switch (_statusObject.Reason) {
      case config.AUTHORIZE_MESSAGE_STATUS.Authorised: {
        editorStatus = CONVERSATION_STATUS.NORMAL;
        break;
      }
      case config.AUTHORIZE_MESSAGE_STATUS.Unauthorised: {
        editorStatus = CONVERSATION_STATUS.UNAUTHORIZED;
        break;
      }
      case config.AUTHORIZE_MESSAGE_STATUS.QuotaLimitGuestSender:
      case config.AUTHORIZE_MESSAGE_STATUS.QuotaLimitPlatinumReceived:
      case config.AUTHORIZE_MESSAGE_STATUS.UnmatchingGuestToPlatinum: {
        editorStatus = CONVERSATION_STATUS.GET_ACCESS;
        break;
      }
      case config.AUTHORIZE_MESSAGE_STATUS.QuotaLimit: {
        editorStatus = isMobileWeb ? CONVERSATION_STATUS.GET_ACCESS_MORE : CONVERSATION_STATUS.MESSAGE_RESET_24H;
        break;
      }
      case config.AUTHORIZE_MESSAGE_STATUS.QuotaLimitMax: {
        editorStatus = CONVERSATION_STATUS.MESSAGE_RESET_24H;
        break;
      }
      case config.AUTHORIZE_MESSAGE_STATUS.UnauthorisedSendToAustralia: {
        editorStatus = CONVERSATION_STATUS.UNAUTHORIZE_AUS;
        break;
      }
      case config.AUTHORIZE_MESSAGE_STATUS.AccountVerificationRequired:
        editorStatus = CONVERSATION_STATUS.ACCOUNT_VERIFICATION_REQUIRED;
        break;
      case config.AUTHORIZE_MESSAGE_STATUS.UsernameRejected:
        editorStatus = CONVERSATION_STATUS.USERNAME_REJECT;
        break;
      case config.AUTHORIZE_MESSAGE_STATUS.ReplyLimitReached: {
        editorStatus = CONVERSATION_STATUS.CAN_NOT_SEND;
        break;
      }
      case config.AUTHORIZE_MESSAGE_STATUS.ReplyNotPossible:
      case config.AUTHORIZE_MESSAGE_STATUS.InboxLocked: {
        editorStatus = CONVERSATION_STATUS.INBOX_LOCKED;
        break;
      }
      case config.AUTHORIZE_MESSAGE_STATUS.AccountAwaitingApproval: {
        editorStatus = CONVERSATION_STATUS.WAITINGAPPROVAL;
        break;
      }
      case config.AUTHORIZE_MESSAGE_STATUS.RequireVerification: {
        editorStatus = CONVERSATION_STATUS.REQUIRE_VERIFICATION;
        break;
      }
      case config.AUTHORIZE_MESSAGE_STATUS.ReceiverRequiresVerification: {
        editorStatus = CONVERSATION_STATUS.RECEIVER_REQUIRE_VERIFICATION;
        break;
      }
      case config.AUTHORIZE_MESSAGE_STATUS.SenderRequiresReceiverVerification: {
        editorStatus = CONVERSATION_STATUS.SENDER_REQUIRES_RECEIVER_VERIFICATION;
        break;
      }
      case config.AUTHORIZE_MESSAGE_STATUS.SenderBanned: {
        editorStatus = CONVERSATION_STATUS.SENDER_BANNED;
        break;
      }
      default: {
        editorStatus = CONVERSATION_STATUS.GET_ACCESS;
        break;
      }
    }

    // TODO should remove, this is hard code

    let canSendVideo = _statusObject.CanVideoCall;
    if (!webIMConfig.isVideoAuthorization) {
      canSendVideo = true;
    }
    const canSendPrivate = !!_statusObject.CanSendPrivate;
    const canSendPhotos = !!_statusObject.CanSendPhotos;
    let memberLevelUserLogin = MEMBER_TYPES.PLATINUM_DIAMOND;
    if (!_statusObject.SenderIsDiamond) {
      memberLevelUserLogin =
        _statusObject.SenderMemberLevel && _statusObject.SenderMemberLevel.Value ? _statusObject.SenderMemberLevel.Value : 1;
    }
    let receiverMemberLevel = MEMBER_TYPES.PLATINUM_DIAMOND;
    if (!_statusObject.ReceiverIsDiamond) {
      receiverMemberLevel =
        _statusObject.ReceiverMemberLevel && _statusObject.ReceiverMemberLevel.Value ? _statusObject.ReceiverMemberLevel.Value : 1;
    }

    const isRecvMatching = _statusObject.ReceiverProfileMatching ? _statusObject.ReceiverProfileMatching : false;
    const isSenderMatching = _statusObject.SenderProfileMatching ? _statusObject.SenderProfileMatching : false;
    const timeToReset = _statusObject.TimeToReset ? _statusObject.TimeToReset : 0;
    convStatus.status = editorStatus;
    // convStatus.remaining = 0;
    convStatus.remaining = _statusObject.Remaining;
    convStatus.canSend = _statusObject.CanSend;
    convStatus.reason = _statusObject.Reason;
    convStatus.canVideoCall = canSendVideo;
    convStatus.canSendPrivate = canSendPrivate;
    convStatus.canSendPhotos = _statusObject.CanSendPhotos;
    convStatus.memberLevelUserLogin = memberLevelUserLogin;
    convStatus.isRecvMatching = isRecvMatching;
    convStatus.isSenderMatching = isSenderMatching;
    convStatus.receiverMemberLevel = receiverMemberLevel;
    convStatus.timeToReset = timeToReset;
    convStatus.conversationKey = _statusObject.ConversationKey || '';
    // convStatus.remainingCredits = 1;
    convStatus.remainingCredits = _statusObject.RemainingCredits || 0;
    // convStatus.upgradeAction = MESSENGER_UPGRADE_ACTION.CREDITS;
    convStatus.upgradeAction = _statusObject.UpgradeAction;
    convStatus.conversationKey = _statusObject.ConversationKey;
    convStatus.isCreditSend = _statusObject.IsCreditSend || false;
    convStatus.canSendGifts = _statusObject.CanSendGifts;
    convStatus.messageBanExpiry = _messageBanExpiry;
    convStatus.sendPhotosBanExpiry = _sendPhotosBanExpiry;
    return convStatus;
  }
}

export default ConversationStatus;
